import { MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

const BACKBLAZE_URL = environment.apiUrl + "/backblaze"
const PROPERTY_URL = environment.apiUrl + "/property/";

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(private _snackBar: MatSnackBar, private http: HttpClient, private route: ActivatedRoute, private router: Router) { }
  apiUrl1 = BACKBLAZE_URL + "/uploadFileToServer";
  FileDeleteURL = environment.apiUrl + "/backblaze";

  getImageData(Ref_FileId: string) {
    // const userId = localStorage.getItem("userId");
    //console.log(Ref_FileId)
    return this.http.get<{ message: string, Response: JSON, code: string }>(
      BACKBLAZE_URL + "/getFile", {
      params: {
        fileId: Ref_FileId
      }
    })
  }

  uploadFileToServer(fileName, fileContent) {
    let postData = {
      filename: fileName,
      filecontent: fileContent,
    };
    return this.http.post<any>(`${this.apiUrl1}`, postData)

  }

  showSuccessMessageforAdd(title: string) {
    this._snackBar.open(title + " added successfully.", "OK", {
      duration: 3000,
    });
  }

  showSuccessMessageforUpdate(title: string) {
    this._snackBar.open(title + " updated successfully.", "OK", {
      duration: 3000,
    });
  }

  showMessage(message: string, action: string) {
    let snackBarRef = this._snackBar.open(message, action, {
      duration: 3000,
    });
    snackBarRef.onAction().subscribe(() => {
      if (action == "Register Now") {
        this.router.navigate(['./authentication/register']);
      }
    });
  }

  updateFieldsOnPDF(fields) {
    return this.http.post("http://customlease.rentblazr.net/api/Agreement", fields, { responseType: 'blob' });
  }

  getPropertyList() {
    return this.http.get<{ Response: any; }>(PROPERTY_URL + 'propertyList')
  }

  deleteFileRecipt(targetIds) {

    const userId = localStorage.getItem("userId");
    return this.http.put(this.FileDeleteURL + "/deleteFile", targetIds
      , {
        params: {
          UserId: userId,
        }
      })
  }
}
